import * as Int64Buffer from "int64-buffer";

function int32array(len) {
  return new Int32Array(len);
}

function uint8array(len) {
  return new Uint8Array(len);
}

function int8array(len) {
  return new Int8Array(len);
}

function uint16array(len) {
  return new Int16Array(len);
}

function int16array(len) {
  return new Int16Array(len);
}

function uint64array(len) {
  return new Int64Buffer.UInt64BE(len);
}

function int64array(len) {
  return new Int64Buffer.Int64BE(len).toArray();
}

function float32array(len) {
  return new Float32Array(len);
}

function float64array(len) {
  return new Float64Array(len);
}

function to_js_int32(arr) {
  return arr;
}

function to_js_float32(arr) {
  return arr;
}

function to_js_float64(arr) {
  return arr;
}

function of_js_int32(arr) {
  return arr;
}

function of_js_int64(arr) {
  return arr;
}

function of_js_float32(arr) {
  return arr;
}

function of_js_float64(arr) {
  return arr;
}

export { int32array, uint8array, int8array, uint16array, int16array, uint64array, int64array, float32array, float64array, to_js_int32, to_js_float32, to_js_float64, of_js_int32, of_js_int64, of_js_float32, of_js_float64 };
/* int64-buffer Not a pure module */